<template>
  <div v-if="tagNode">
    <h2><span style="font-size: 14px;" v-for="ancestor in tagNode.ancestors" :key="ancestor.id">{{ ancestor.name }} > </span>{{ tagNode.name }}</h2>
    <div>
      <div class="flex justify-between">
        <h3>Stars</h3>
        <button
          data-toggle="modal"
          data-target="#modal-tag-node-add-talent"
          data-backdrop="static"
        ><i class="fa fa-plus"></i> Add</button>
      </div>
      <ul>
        <li v-for="talent in tagNode.talent" :key="talent.id">
          <input :id="'talent-checkbox-' + talent.id" type="checkbox" :value="talent.id" v-model="selectedTalent">
          <label :for="'talent-checkbox-' + talent.id">{{ talent.name }}</label>
        </li>
      </ul>
      <div>
        <div v-if="selectedTalent.length">{{ selectedTalent.length }} stars selected</div>
        <button @click="() => { this.searching = !this.searching }" :disabled="!selectedTalent.length"><i class="fa fa-share"></i> Move</button>
        <button @click="deleteTalent" :disabled="!selectedTalent.length"><i class="fa fa-trash"></i> Delete</button>
        <div v-if="searching">
          <input v-model="searchString" @keypress.enter="searchNodes">
          <button @click="searchNodes"><i class="fa fa-search"></i></button>
          <div v-for="result in searchResults" :key="result.id">
            <div class="flex">
            <span style="font-size: 12px;" v-for="ancestor in result.ancestors" :key="ancestor.id">
              {{ ancestor.name }} >
            </span>
              {{ result.name }}
            </div>
            <button @click="() => { moveTalent(result.id) }"><i class="fa fa-mail-forward"></i></button>
          </div>
        </div>
      </div>
    </div>
    <system-tag-node-add-talent-modal @add="(selected) => { this.addTalent(selected) }"></system-tag-node-add-talent-modal>
  </div>
</template>

<script>
import { http } from 'utils'
import SystemTagNodeAddTalentModal from './SystemTagNodeAddTalentModal'

export default {
  components: {
    SystemTagNodeAddTalentModal
  },
  props: ['id'],

  data () {
    return {
      tagNode: null,
      selectedTalent: [],
      searchResults: [],
      searchString: '',
      searching: false
    }
  },

  created () {
    let id = this.$route.params.id
    http.get(`tag-node/${id}`).then(response => {
      this.tagNode = response.data
    })
  },

  methods: {
    deleteTalent () {
      http.post(`tag-node/${this.$route.params.id}/delete-talent`, { selectedTalent: this.selectedTalent })
    },

    moveTalent (otherTagId) {
      http.post(`tag-node/${this.$route.params.id}/move-talent`, { selectedTalent: this.selectedTalent, otherTagId })
    },

    addTalent (selectedTalent) {
      http.post(`tag-node/${this.$route.params.id}/add-talent`, { selectedTalent })
    },

    searchNodes () {
      http.get(`/tag-nodes`, { params: { search: this.searchString } }).then(response => {
        this.searchResults = response.data
      })
    }
  }
}
</script>
